import OrderTypeEnum from '@/app-core/api/enums/OrderTypeEnum'
import CartActions from '@/app-core/mixins/cart/cartActions'
import CartComponents from '@/app-core/mixins/cart/cartComponents'
import Translatable from '@/app-core/mixins/translatable'
import DeliveryServiceCommon from '@/app-core/mixins/services/deliveryServiceCommon'

export default {
  name      : 'OrderTypeSelector',
  components: {},
  directives: {},
  mixins    : [CartComponents, CartActions, DeliveryServiceCommon, Translatable],
  enums     : {OrderTypeEnum},
  props     : {
    dense: {
      type   : Boolean,
      default: false
    },

    showSelectedNameOnly: {
      type   : Boolean,
      default: false
    }
  },
  data() {
    return {
      orderTypeModel: OrderTypeEnum.COLLECTION
    }
  },
  computed: {},
  watch   : {},
  beforeCreate() {
  },
  created() {
    this.$bus.$on('after:cart:set-data', this.updateLocalModel)
    this.orderTypeModel = this.AppCart.OrderType || this.AppConfig.Marketplace.DefaultOrderType || OrderTypeEnum.COLLECTION
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
    this.$bus.$off('after:cart:set-data', this.updateLocalModel)
  },
  destroyed() {
  },
  methods: {
    updateLocalModel(cardData) {
      if (this.orderTypeModel === cardData.OrderType) return

      this.orderTypeModel = cardData.OrderType
    },

    onSelectorChange(newVal) {
      if (newVal === this.AppCart.OrderType) return

      this.$bus.$emit('cart:update-order-type', newVal)
    }
  }
}
